export default __webpack_public_path__ + "static/teambuilding-fc9a842bfda10073c6bb7684bb8e8d52.jpg";